module.exports = __webpack_public_path__ + "static/img/logo.a2fa73f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo.png
// module id = dLd/
// module chunks = 1